<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="tcf-notedit" v-if="!isauth">
          <div class="tcf-notedit-spinner">
            未授权小程序，<router-link to="/work/delxcxsz" class="a-txt">点击这里立即去授权</router-link>
          </div>
        </div>
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="风格">
              <el-select v-model="searchForm.style" style="width: 120px" filterable clearable>
                <el-option v-for="style in styleList" :key="style.sid" :label="style.name" :value="style.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="面积">
              <el-select v-model="searchForm.area" style="width: 120px" filterable clearable>
                <el-option v-for="area in areaList" :key="area.aid" :label="area.name" :value="area.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="居室">
              <el-select v-model="searchForm.room" style="width: 120px" filterable clearable>
                <el-option v-for="room in bedRoomList" :key="room.bid" :label="room.name" :value="room.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="addTemplate">添加案例</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="caseList"
                  stripe
                  style="width: 100%"
                >
                  <el-table-column
                    label="封面"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                      <el-image
                        :src="scope.row.imgUrl"
                        fit="cover"
                        style="height: 40px;"
                        :preview-src-list="[scope.row.imgUrl]"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="标题"
                    width="200"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="remark"
                    label="描述"
                    min-width="200"
                    show-overflow-tooltip
                  />
<!--                  <el-table-column-->
<!--                    prop="brandName"-->
<!--                    label="品牌"-->
<!--                    width="100"-->
<!--                    align="center"-->
<!--                    show-overflow-tooltip>-->
<!--                  </el-table-column>-->
                  <el-table-column
                    prop="style"
                    label="风格"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="room"
                    label="居室"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="area"
                    label="面积"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="amount"
                    label="预算"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="views"
                    label="浏览量"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="username"
                    label="发布人"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.delid==='0'">总部</span>
                      <span v-if="scope.row.delid!=='0'">{{scope.row.username}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="发布时间"
                    width="200"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    label="首页展示"
                    align="center"
                    width="100"
                    fixed="right">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.isindex===0" :disable-transitions="true" size="mini" type="info">不展示</el-tag>
                      <el-tag v-if="scope.row.isindex===1" :disable-transitions="true" size="mini">展示</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="200"
                    align="center"
                    fixed="right">
                    <template slot-scope="scope">
                      <el-button :disabled="scope.row.delid==='0'" icon="el-icon-edit" size="mini" @click="editTemplate(scope.row)">修改</el-button>
                      <el-button :disabled="scope.row.delid==='0'" icon="el-icon-delete" size="mini" @click="deleteTemplate(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  style="margin-top: 20px;"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="封面图" prop="img">
          <span style="color:#99a9bf;"><i class="el-icon-warning"></i> 建议上传750*280尺寸的图片</span>
          <SingleImg :key="imgKey" v-model="addForm.img" :oldurl="addForm.oldimgurl" :size="[375,140]" />
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="风格" prop="style">
              <el-select v-model="addForm.style" filterable clearable>
                <el-option v-for="style in styleList" :key="style.sid" :label="style.name" :value="style.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="面积" prop="area">
              <el-select v-model="addForm.area" filterable clearable>
                <el-option v-for="area in areaList" :key="area.aid" :label="area.name" :value="area.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="居室" prop="room">
              <el-select v-model="addForm.room" filterable clearable>
                <el-option v-for="room in bedRoomList" :key="room.bid" :label="room.name" :value="room.name" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <el-input
            v-model="addForm.remark"
            maxlength="500"
            type="textarea"
            :rows="3"
            show-word-limit
          />
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="预算" prop="amount">
              <el-input v-model="addForm.amount" maxlength="20" show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="浏览量" prop="views">
              <el-input-number
                v-model="addForm.views"
                :precision="0"
                :min="1"
                :max="10000"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="首页展示" prop="isindex">
              <el-switch v-model="addForm.isindex">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详情" prop="content">
          <Tinymce v-if="dialogVisible" v-model="addForm.content" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="btnLoading" @click="submitTemplate">立即提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce/index'
import { getUser } from '@/utils/auth'
import { addOrEditCase, delCase, getAreaList, getBedRoomList, getCaseList } from '@/api/community'
import { getWxStyleList } from '@/api/pub'
import SingleImg from '@/components/upload/SingleImg'
import { getDealerDetail } from '@/api/work'
import { getDelShopInfo } from '@/api/dealer'

export default {
  name: 'delalgl',
  components: {
    SingleImg,
    Tinymce
  },
  data() {
    return {
      imgKey: '',
      bid: 0,
      loading: false,
      remarkVisible: false,
      dialogTitle: '',
      dialogVisible: false,
      btnLoading: false,
      styleList: [],
      areaList: [],
      bedRoomList: [],
      searchForm: {
        style: '',
        area: '',
        room: '',
        search: ''
      },
      caseList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      addForm: {
        img: null,
        oldimgurl: '',
        style: '',
        room: '',
        area: '',
        title: '',
        remark: '',
        amount: '',
        content: '',
        views: null,
        id: null,
        isindex: false
      },
      addRules: {
        style: [{ required: true, message: '请选择风格', trigger: 'change' }],
        area: [{ required: true, message: '请选择面积', trigger: 'change' }],
        room: [{ required: true, message: '请选择居室', trigger: 'change' }],
        remark: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入预算', trigger: 'blur' }],
        img: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        content: [{ required: true, message: '请输入文本', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        views: [{ required: true, message: '请输入浏览量', trigger: 'blur' }]
      },
      isauth: true
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getBrandList()
    this.getAreaList()
    this.getBedRoomList()
    getDelShopInfo({ delid: this.user.delid }).then(response => {
      if (response.data !== null && response.data !== undefined) {
        if (response.data.appid === null || response.data.appid === '' || response.data.appid === undefined) {
          this.isauth = false
        }
      } else {
        this.isauth = false
      }
    })
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        brand: this.bid,
        area: this.searchForm.area,
        style: this.searchForm.style,
        room: this.searchForm.room,
        delid: this.user.delid,
        search: this.searchForm.search
      }
      getCaseList(data).then(response => {
        this.caseList = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    getBrandList() {
      getDealerDetail({ delid: this.user.delid }).then(response => {
        if (response.data.brandlst.length > 0) {
          this.bid = response.data.brandlst[0].bid
          this.getStyleList()
        }
        this.getData()
      })
    },
    getAreaList() {
      getAreaList().then(response => {
        this.areaList = response.data
      })
    },
    getStyleList() {
      getWxStyleList({}).then(response => {
        let _styleList = []
        for (const s of response.data) {
          if (s.bid === this.bid) {
            _styleList.push(s)
          }
        }
        this.styleList = _styleList
      })
    },
    getBedRoomList() {
      getBedRoomList().then(response => {
        this.bedRoomList = response.data
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    addTemplate() {
      this.addForm.id = 0
      this.addForm.area = ''
      this.addForm.room = ''
      this.addForm.style = ''
      this.addForm.delid = ''
      this.addForm.title = ''
      this.addForm.remark = ''
      this.addForm.amount = ''
      this.addForm.views = null
      this.addForm.img = null
      this.addForm.oldimgurl = null
      this.addForm.isindex = false
      this.addForm.content = ''
      this.dialogTitle = '添加案例'
      this.dialogVisible = true
      this.imgKey = new Date().getTime().toString()
    },
    editTemplate(row) {
      this.imgKey = new Date().getTime().toString()
      this.addForm.id = row.cid
      this.addForm.area = row.area
      this.addForm.room = row.room
      this.addForm.style = row.style
      this.addForm.title = row.title
      this.addForm.remark = row.remark
      this.addForm.amount = row.amount
      this.addForm.views = row.views
      this.addForm.img = { imgid: row.imgid, imgUrl: row.imgUrl }
      this.addForm.oldimgurl = row.imgUrl
      this.addForm.content = row.content
      this.addForm.isindex = row.isindex === 1 ? true : false
      this.dialogTitle = '修改案例'
      this.dialogVisible = true
    },
    deleteTemplate(row) {
      this.$confirm('您确定要删除此案例吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delCase({ id: row.cid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {
      })
    },
    submitTemplate() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            const data = {
              id: this.addForm.id,
              delid: this.user.delid,
              area: this.addForm.area,
              brand: this.bid,
              room: this.addForm.room,
              style: this.addForm.style,
              title: this.addForm.title,
              remark: this.addForm.remark,
              amount: this.addForm.amount,
              views: this.addForm.views,
              imgid: this.addForm.img.imgid,
              content: this.addForm.content,
              role: this.user.rank,
              userid: this.user.userid,
              isindex: this.addForm.isindex ? 1 : 0
            }
            addOrEditCase(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
